<template>
  <div class="flex col wrapper">
    <FormHeading :h="5">{{ header }}</FormHeading>
    <span class="mb-2">
      {{ body }}
    </span>
    <LightBtn icon="mdi:panorama-outline" class="btn" @click="modalOpen = true">
      {{ $tt('illustation') }}: {{ header }}
    </LightBtn>
    <AppOverlay v-model="modalOpen">
      <AppImg :src />
    </AppOverlay>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  header: string;
  body: string;
  src: string;
}>();

const modalOpen = ref(false);
</script>

<style scoped>
.btn {
  margin-top: auto;
}
.wrapper {
  height: 100%;
}
</style>